import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, BookOpen, Star, User } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
import t from '../translations';

export default function BottomNav() {
  const navigate  = useNavigate();
  const { pathname } = useLocation();
  const { lang }  = useLang();
  const tr = t[lang];

  const NAV_ITEMS = [
    { path: '/home',     icon: Home,     label: tr.navHome    },
    { path: '/reading',  icon: BookOpen, label: tr.navReading },
    { path: '/chart',    icon: Star,     label: tr.navChart   },
    { path: '/settings', icon: User,     label: tr.navProfile },
  ];

  return (
    <nav
      data-testid="bottom-nav"
      style={{
        position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
        width: '100%', maxWidth: 480,
        background: 'rgba(10,15,30,0.95)', backdropFilter: 'blur(12px)',
        borderTop: '1px solid rgba(201,168,76,0.12)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-around',
        paddingBottom: 'env(safe-area-inset-bottom, 8px)',
        paddingTop: 8, zIndex: 200,
      }}
    >
      {NAV_ITEMS.map(({ path, icon: Icon, label }) => {
        const active = pathname === path || (path === '/reading' && pathname.startsWith('/reading'));
        return (
          <button
            key={path}
            data-testid={`nav-${path.slice(1)}`}
            onClick={() => navigate(path)}
            style={{
              flex: 1, display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center', gap: 4,
              padding: '6px 0', background: 'none', border: 'none', cursor: 'pointer',
              transition: 'all 0.15s',
            }}
          >
            <Icon
              size={22}
              color={active ? '#C9A84C' : '#8A8580'}
              strokeWidth={active ? 2.2 : 1.8}
              style={{ transition: 'color 0.15s, transform 0.15s', transform: active ? 'scale(1.08)' : 'none' }}
            />
            <span style={{
              fontSize: 10, fontWeight: active ? 700 : 400,
              color: active ? '#C9A84C' : '#8A8580',
              letterSpacing: '0.03em',
              fontFamily: lang === 'hi' ? "'Noto Sans Devanagari', sans-serif" : "'Inter', sans-serif",
            }}>
              {label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
